module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 5
// module chunks = 0